import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TokenGuard } from "../App"; // Assuming TokenGuard is correctly implemented
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faSignOutAlt, faTimesCircle } from "@fortawesome/free-solid-svg-icons"; // Added icons

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");

      // Check if token exists before making the API call
      if (!token) {
        toast.info("You are already logged out.");
        navigate("/");
        return;
      }

      await axios.post(
        "https://backend.inyumba.co.ke/iNyumba/auth/logout",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Logout successful!");
      localStorage.clear(); // Clear token and other data
      navigate("/"); // Redirect to login page
    } catch (error) {
      console.error("Logout error:", error);
      if (error.response && error.response.status === 401) {
        toast.error("Session expired or unauthorized. Logging out...");
        localStorage.clear(); // Clear invalid token
        navigate("/"); // Redirect to login
      } else {
        toast.error("Failed to log out. Please try again.");
      }
    }
  };

  const handleNo = () => {
    // Navigate back to the user's dashboard or previous page
    navigate("/user/myapartment");
  };

  return (
    <TokenGuard>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
   
        <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-8 text-center space-y-6 animate-fade-in">
          <FontAwesomeIcon icon={faQuestionCircle} className="text-indigo-400 text-6xl mx-auto mb-4" />
          <h2 className="text-3xl font-semibold text-gray-800">
            Are you sure you want to log out?
          </h2>
          <p className="text-gray-600 text-lg">
            You will need to sign in again to access your account.
          </p>
          <div className="flex justify-center space-x-6 pt-4">
            <button
              onClick={handleLogout}
              className="flex items-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium text-lg shadow-md transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Yes, Log Out</span>
            </button>
            <button
              onClick={handleNo}
              className="flex items-center space-x-2 bg-gray-200 text-gray-800 hover:bg-gray-300 px-6 py-3 rounded-lg font-medium text-lg shadow-sm transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
            >
              <FontAwesomeIcon icon={faTimesCircle} />
              <span>No, Stay Signed In</span>
            </button>
          </div>
        </div>
      </div>
    </TokenGuard>
  );
};

export default Logout;